(() => {
  const i18n = window.MayLondonI18n;
  const { t } = i18n;
  if (window.MayLondonProduct) return;
  window.MayLondonProduct = true;
  const config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}');
  const controllers = new Map();
  const money = i18n.money;
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  function init(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach((section) => {
      if (controllers.has(section)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const observers = [];
      controllers.set(section, () => { controller.abort(); observers.forEach((observer) => observer.disconnect()); });
      const form = section.querySelector('.js-product-form');
      const select = form?.querySelector('[data-variant-select]');
      if (!select) return;
      const inputs = [...form.querySelectorAll('[data-product-option]')];
      const variants = [...select.options].map((option) => ({
        id: option.value, title: option.textContent.trim(), options: JSON.parse(option.dataset.options),
        available: option.dataset.available === 'true', price: Number(option.dataset.price), compare: Number(option.dataset.compare),
        inventory: Number(option.dataset.inventory), managed: option.dataset.managed === 'true', policy: option.dataset.policy, mediaId: option.dataset.mediaId
      }));
      const submit = form.querySelector('[data-product-submit]');
      const sticky = section.querySelector('[data-mobile-sticky-atc]');
      const stickySubmit = section.querySelector('[data-mobile-sticky-submit]');
      const stock = section.querySelector('[data-stock-status]');
      const restock = section.querySelector('[data-back-in-stock]');
      const track = section.querySelector('[data-gallery-track]');
      section.querySelectorAll('.product-gallery__item').forEach(figure => {
        const photo = figure.querySelector(':scope > img');
        const mark = figure.querySelector(':scope > .product-watermark');
        if (!photo || !mark) return;
        const fitWatermark = () => {
          if (!photo.naturalWidth || !photo.naturalHeight) return;
          const scale = Math.min(photo.clientWidth / photo.naturalWidth, photo.clientHeight / photo.naturalHeight);
          mark.style.width = photo.naturalWidth * scale + 'px';
          mark.style.height = photo.naturalHeight * scale + 'px';
        };
        photo.addEventListener('load', fitWatermark, options);
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(fitWatermark);
          observer.observe(photo); observers.push(observer);
        } else window.addEventListener('resize', fitWatermark, options);
        fitWatermark();
      });
      const quantityOffers = window.MayLondonQuantity?.(section, form, variants, options, variant => {
        select.value = variant.id;
        inputs.forEach(input => { input.checked = variant.options[Number(input.dataset.optionPosition)] === input.value; });
        sync(true);
      });

      const showMedia = (id, animate = true) => {
        const media = [...section.querySelectorAll('[data-media-id]')].find((el) => el.dataset.mediaId === id && el.tagName === 'FIGURE');
        if (!media || !track) return;
        track.scrollTo({ left: track.scrollLeft + media.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: animate ? motion() : 'auto' });
      };

      const sync = (updateURL = false, updateMedia = true) => {
        const values = inputs.length ? [] : variants.find((variant) => variant.id === select.value)?.options || [];
        inputs.filter((input) => input.checked).forEach((input) => { values[Number(input.dataset.optionPosition)] = input.value; });
        const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));
        select.disabled = !variant;
        if (variant) select.value = variant.id;
        section.querySelectorAll('[data-selected-option]').forEach((el) => { el.textContent = values[Number(el.dataset.selectedOption)] || ''; });
        [submit, stickySubmit].filter(Boolean).forEach((button) => {
          button.disabled = !variant?.available || form.dataset.busy === 'true';
          button.textContent = !variant ? t('unavailable') : variant.available ? button.dataset.addText || t('add_to_bag') : t('sold_out');
        });
        inputs.forEach((input) => {
          const position = Number(input.dataset.optionPosition);
          const matches = variants.filter((item) => item.options[position] === input.value && item.options.slice(0, position).every((value, index) => value === values[index]));
          input.disabled = !matches.some(item => item.available) || form.dataset.busy === 'true';
          input.nextElementSibling?.classList.toggle('is-sold-out', matches.length > 0 && !matches.some((item) => item.available));
          input.nextElementSibling?.classList.toggle('is-unavailable', matches.length === 0);
          input.title = matches.length === 0 ? t('unavailable_combination') : !matches.some((item) => item.available) ? t('sold_out') : input.value;
          const optionStatus = input.nextElementSibling?.querySelector('[data-option-stock]');
          if (optionStatus) { optionStatus.hidden = matches.some(item => item.available); optionStatus.textContent = input.title; }
        });
        if (restock) {
          restock.hidden = !variant || variant.available;
          restock.querySelector('[name="variant_id"]').value = variant?.id || '';
          restock.querySelector('[data-restock-message]').textContent = '';
        }
        const gauge = section.querySelector('[data-stock-gauge]');
        if (!variant) { if (stock) { stock.textContent = t('combination_unavailable'); delete stock.dataset.stockLevel; stock.classList.remove('is-low-stock', 'is-sold-out'); } if (gauge) gauge.hidden = true; quantityOffers?.update(null); return; }
        section.querySelectorAll('[data-product-price], [data-sticky-product-price]').forEach((el) => { el.textContent = money(variant.price); });
        const compare = section.querySelector('[data-product-compare]');
        section.querySelectorAll('[data-product-sale]').forEach(badge => { badge.hidden = variant.compare <= variant.price; });
        const save = section.querySelector('[data-product-save]');
        if (compare) { compare.hidden = variant.compare <= variant.price; compare.textContent = money(variant.compare); }
        if (save) { save.hidden = variant.compare <= variant.price; save.textContent = variant.compare > variant.price ? t('save_percent', {percent:i18n.percent(Math.floor((variant.compare - variant.price) * 100 / variant.compare))}) : ''; }
        if (stock) {
          stock.dataset.stockVariant = variant.id;
          const quantity = Math.max(0, Math.min(10, variant.inventory));
          const counted = variant.managed && !(variant.inventory <= 0 && variant.policy === 'continue' && variant.available);
          const low = counted && variant.inventory > 0 && variant.inventory <= 5;
          const critical = variant.available && counted && variant.inventory > 0 && variant.inventory <= 3;
          const level = critical ? 'critical' : !variant.available || low ? 'low' : counted && quantity < 10 ? 'medium' : 'high';
          stock.textContent = !variant.available ? t('sold_out') : counted ? variant.inventory >= 10 ? t('stock_max') : t('stock', {}, quantity) : variant.managed && variant.inventory <= 0 && variant.policy === 'continue' ? t('available_order') : stock.dataset.inStockText;
          stock.dataset.stockLevel = level;
          if (gauge) {
            gauge.hidden = variant.available && !counted;
            gauge.dataset.stockLevel = level;
            gauge.setAttribute('aria-valuenow', String(variant.available ? quantity : 0));
            gauge.setAttribute('aria-valuetext', stock.textContent);
            gauge.style.setProperty('--stock-fill', `${variant.available ? quantity * 10 : 0}%`);
          }
          stock.classList.toggle('is-low-stock', low && variant.available);
          stock.classList.toggle('is-sold-out', !variant.available);
        }
        if (variant.mediaId && updateMedia) showMedia(variant.mediaId, updateURL);
        if (updateURL && !window.Shopify?.designMode) {
          const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(history.state, '', url);
        }
        section.querySelectorAll('[data-wishlist-price]').forEach((el) => { el.dataset.wishlistPrice = variant.price; });
        quantityOffers?.update(variant);
        return variant;
      };
      form.addEventListener('change', (event) => {
        if (event.target === select) {
          const selected = variants.find(variant => variant.id === select.value);
          inputs.forEach(input => { input.checked = selected?.options[Number(input.dataset.optionPosition)] === input.value; });
        }
        if (event.target.matches('[data-product-option]') && !event.target.disabled) {
          const position = Number(event.target.dataset.optionPosition), values = [];
          inputs.filter(input => input.checked).forEach(input => { values[Number(input.dataset.optionPosition)] = input.value; });
          const allowed = variant => variant.available && (!quantityOffers || quantityOffers.available(variant));
          const exact = variants.find(variant => allowed(variant) && variant.options.every((value, i) => value === values[i]));
          const next = exact || variants.find(variant => allowed(variant) && variant.options.slice(0, position + 1).every((value, i) => value === values[i]));
          if (next) inputs.forEach(input => { input.checked = next.options[Number(input.dataset.optionPosition)] === input.value; });
        }
        if (event.target === select || event.target.matches('[data-product-option]')) sync(true);
      }, options);
      form.addEventListener('may-london:cart-settled', () => sync(), options);
      let inventoryBusy = false;
      const refreshInventory = async () => {
        if (inventoryBusy || document.hidden || !section.isConnected || window.Shopify?.designMode) return;
        inventoryBusy = true;
        try {
          const url = new URL(location.href);
          url.search = '';
          url.searchParams.set('section_id', 'product-inventory');
          const response = await fetch(url, { signal: AbortSignal.any([controller.signal, AbortSignal.timeout(15000)]), headers: { Accept: 'text/html' }, cache: 'no-store' });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(html.querySelector('[data-stock-snapshot]')?.textContent || 'null');
          if (!data || String(data.product) !== section.dataset.productId || !Array.isArray(data.variants)) return;
          for (const item of data.variants) {
            const variant = variants.find(variant => variant.id === String(item.id));
            if (!variant || !Number.isFinite(item.quantity) || typeof item.available !== 'boolean' || typeof item.managed !== 'boolean' || !['deny', 'continue'].includes(item.policy)) continue;
            Object.assign(variant, { inventory: item.quantity, available: item.available, managed: item.managed, policy: item.policy });
            const option = [...select.options].find(option => option.value === variant.id);
            if (option) { option.dataset.available = String(variant.available); option.dataset.inventory = String(variant.inventory); }
          }
          sync(false, false);
        } catch (_) { /* Keep the last confirmed state; Shopify validates stock when adding. */ }
        finally { inventoryBusy = false; }
      };
      const inventoryTimer = setInterval(refreshInventory, 30000);
      controller.signal.addEventListener('abort', () => clearInterval(inventoryTimer), { once: true });
      document.addEventListener('visibilitychange', refreshInventory, options);
      form.addEventListener('may-london:cart-settled', refreshInventory, options);
      form.addEventListener('change', refreshInventory, options);
      section.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-gallery-select]');
        if (thumbnail) showMedia(thumbnail.dataset.gallerySelect);
        const arrow = event.target.closest('[data-gallery-step]');
        if (arrow && track) {
          const buttons = [...section.querySelectorAll('[data-gallery-select]')];
          const currentIndex = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-current') === 'true'));
          const nextIndex = (currentIndex + Number(arrow.dataset.galleryStep) + buttons.length) % buttons.length;
          if (buttons[nextIndex]) showMedia(buttons[nextIndex].dataset.gallerySelect);
        }
        const play = event.target.closest('[data-load-video]');
        if (play) { const container = play.closest('[data-deferred-video]'); container.replaceChildren(container.querySelector('template').content.cloneNode(true)); }
      }, options);
      if (track && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('[data-gallery-select]').forEach((button) => button.setAttribute('aria-current', String(button.dataset.gallerySelect === entry.target.dataset.mediaId)));
          } else entry.target.querySelectorAll('video').forEach((video) => video.pause());
        }), { root: track, threshold: .65 });
        track.querySelectorAll('figure').forEach((figure) => observer.observe(figure));
        observers.push(observer);
      }
      if (sticky && submit && 'IntersectionObserver' in window) {
        const updateSticky = () => { sticky.hidden = !(matchMedia('(max-width: 700px)').matches && submit.getBoundingClientRect().bottom < 0); };
        const observer = new IntersectionObserver(updateSticky);
        window.addEventListener('resize', updateSticky, options);
        observer.observe(submit); observers.push(observer);
      }
      const current = sync();
      const viewItem = () => { if (current) window.MayLondonTrack?.('view_item', { key: `product-${section.dataset.productId}`, value: current.price / 100, items: [{ item_id: section.dataset.productId, item_name: section.querySelector('h1').textContent, item_variant: current.id, price: current.price / 100, quantity: 1 }] }); };
      viewItem();
      document.addEventListener('may-london:consent-ready', viewItem, options);
    });
  }
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-back-in-stock-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    const message = form.querySelector('[data-restock-message]');
    const button = form.querySelector('[type="submit"]');
    const payload = Object.fromEntries(new FormData(form));
    form.dataset.busy = 'true'; button.disabled = true;
    message.textContent = '';
    try {
      const endpoint = new URL(config.restockEndpoint, location.origin);
      if (endpoint.origin !== location.origin || endpoint.username || endpoint.password || !endpoint.pathname.startsWith('/apps/')) throw new Error(t('restock_unavailable'));
      if (endpoint.search || endpoint.hash) throw new Error(t('restock_unavailable'));
      const response = await fetch(endpoint, { method: 'POST', credentials: 'same-origin', mode: 'same-origin', redirect: 'error', referrerPolicy: 'no-referrer', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...payload, locale: config.locale }), signal: AbortSignal.timeout(15000) });
      const result = await response.json();
      if (!response.ok || !result.subscription_id) throw new Error(t('restock_error'));
      if (form.querySelector('[name="variant_id"]').value === payload.variant_id) message.textContent = t('restock_success');
    } catch (error) { message.textContent = i18n.message(error, 'restock_error'); }
    finally { form.dataset.busy = 'false'; button.disabled = false; }
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((dispose, section) => { if (event.target.contains(section)) { dispose(); controllers.delete(section); } });
  });
  init();
})();
